var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jsonretro"},[_c('div',{staticClass:"jsonretro__json-container"},[_c('pre',{staticClass:"jsonretro__json"},[_vm._v(_vm._s(_vm._f("pretty")(_vm.retroJson)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }